import styles from "./PaymentOption.module.scss";
import classNames from "classnames";
import { paymentContent } from "../tradeInCopyText";
import Tooltip from "@JohnLewisPartnership/jl-design-system/dist/components/tooltip/Tooltip";
import { AvailablePaymentOption } from "../PaymentOptions";

type Props = {
  index: number;
  description: string;
  payment: AvailablePaymentOption;
  selected: boolean;
  onSelect: () => void;
};

const PaymentOption = ({
  index,
  description,
  payment,
  selected,
  onSelect,
}: Props) => {
  return (
    <>
      <div className={styles.payment__tooltip}>
        <Tooltip
          anchor="right"
          icon
          id={"payment-tooltip" + index}
          data-test="payment-tooltip"
          popoverClassname={styles.payment__tooltip_popover}
        >
          <p>{paymentContent[payment.type].tooltipContent}</p>
        </Tooltip>
      </div>

      <button
        data-testid={"paymentBlock" + index}
        data-cy={"paymentBlock" + payment.type}
        className={classNames([
          styles.payment,
          selected && styles["payment--selected"],
        ])}
        key={index}
        onClick={onSelect}
      >
        <h2
          className={styles.payment__type}
          data-cy={`payment-type-${payment.type}`}
        >
          {paymentContent[payment.type].payout}
        </h2>
        <div
          className={styles.payment__inner}
          data-cy={`payment-value-${payment.type}`}
        >
          <h2 className={styles.payment__description}>{description}</h2>
          <h3 className={styles.payment__value}>{payment.displayValue}</h3>
          <p className={styles.payment__valueLabel}>Trade In value</p>
        </div>
      </button>
    </>
  );
};

export default PaymentOption;
